import { cn } from '@/utils/cn';

// Round white buttons for the hover-revealed tool rail that floats over
// artifact images (download, replace image, vibe edit).
export const toolRailButtonClass = cn(
	'flex size-8 items-center justify-center rounded-full',
	'bg-white/85 text-gray-900 shadow-lg ring-1 ring-black/15',
	'backdrop-blur-md transition-colors hover:bg-white',
);
